<section id="educacion">
  <div class="last-reels-ig-main">

    <div class="last-reels-title">
      <span>Educación</span>
      <span> financiera</span>
      <span> a tu alcance</span>
    </div>

    <div class="last-reels-content">
      <div class="reel-layout"></div>
      <div class="reel-layout"></div>
      <div class="reel-layout"></div>
      <div class="reel-layout"></div>
    </div>

    <div class="last-reels-social">
      <button class="facebook"
        (mouseenter)="facebookHovered = true"
        (mouseleave)="facebookHovered = false"
        (click)="openFacebook()">
        <img [src]="facebookHovered ? 'assets/icons/facebook-white.svg' : 'assets/icons/facebook-icon.svg'" alt="Facebook DRAM">
        <span>Facebook DRAM</span>
      </button>

      <button class="instagram"
        (mouseenter)="instagramHovered = true"
        (mouseleave)="instagramHovered = false"
        (click)="openInstagram()">
        <span>Instagram DRAM</span>
        <img [src]="instagramHovered ? 'assets/icons/instagram-white.svg' : 'assets/icons/instagram-icon.svg'" alt="Instagram DRAM">
      </button>
    </div>
  </div>
</section>
